import { render, staticRenderFns } from "./IQConfigurationTab.vue?vue&type=template&id=0d2f896e&scoped=true"
import script from "./IQConfigurationTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IQConfigurationTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQConfigurationTab.vue?vue&type=style&index=0&id=0d2f896e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f896e",
  null
  
)

export default component.exports